import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { History, FileDown } from "lucide-react";
import { downloadSignedContract } from "@/components/ContractPanel";

const ST = {
  uploaded: ["بانتظار المراجعة", "bg-amber-500/10 text-amber-700 border-amber-500/30"],
  rejected: ["مرفوض", "bg-destructive/10 text-destructive border-destructive/30"],
  approved: ["مقبول", "bg-emerald-500/10 text-emerald-700 border-emerald-500/30"],
};
const fmt = (s) => (s ? new Date(s).toLocaleString("ar-SA-u-nu-latn", { dateStyle: "medium", timeStyle: "short" }) : "—");

export function ContractHistoryDialog({ user }) {
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState(null);

  useEffect(() => {
    if (open) api.get(`/admin/users/${user.id}/contract-history`).then((r) => setRows(r.data)).catch(() => setRows([]));
  }, [open, user.id]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" variant="ghost" className="h-8 rounded-lg gap-1" data-testid={`contract-history-${user.id}`}>
          <History className="w-3.5 h-3.5" /> السجل
        </Button>
      </DialogTrigger>
      <DialogContent dir="rtl" className="max-w-lg" data-testid="contract-history-dialog">
        <DialogHeader><DialogTitle>سجل العقود — {user.name}</DialogTitle></DialogHeader>
        <div className="max-h-[60vh] overflow-y-auto divide-y divide-border">
          {rows === null && <div className="py-8 text-center text-sm text-muted-foreground">جارٍ التحميل...</div>}
          {rows?.length === 0 && <div className="py-8 text-center text-sm text-muted-foreground" data-testid="contract-history-empty">لم يُرفع أي عقد بعد</div>}
          {rows?.map((h, i) => (
            <div key={h.file_id} className="py-3 flex items-start justify-between gap-3" data-testid={`contract-version-${h.file_id}`}>
              <div className="min-w-0 space-y-1">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-semibold">النسخة {rows.length - i}</span>
                  {ST[h.status] && <Badge variant="outline" className={ST[h.status][1]}>{ST[h.status][0]}</Badge>}
                </div>
                <div className="text-xs text-muted-foreground">رُفعت {fmt(h.uploaded_at)}{h.reviewed_at && ` · رُوجعت ${fmt(h.reviewed_at)}`}</div>
                {h.note && <div className="text-xs text-destructive whitespace-pre-line" data-testid={`contract-version-note-${h.file_id}`}>{h.note}</div>}
              </div>
              <Button size="sm" variant="outline" className="rounded-full gap-1 shrink-0"
                onClick={() => downloadSignedContract(h.file_id, `${user.name}-v${rows.length - i}`).catch(() => toast.error("تعذّر تحميل العقد"))}
                data-testid={`contract-version-download-${h.file_id}`}>
                <FileDown className="w-3.5 h-3.5" /> تنزيل
              </Button>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
